module.exports = __webpack_public_path__ + "img/powerOutage.2e8319cf.svg";